// Words for a signature / load on the Shipping hub (Out for delivery rows, History, the result cards). Pure.
//
// sign  (GET /shipping/so-board order.sign, GET /shipping/loads rows): {request_id, kind, status, signed_by, signed_at,
//        has_problem, signature_method?}   status pending | signed | expired | void
// load  (order.load / a loads row): {load_id, driver | driver_name | carrier_name, vehicle | vehicle_name | vehicle_text,
//        loaded_at, loaded_by}
import { clockText } from './signRequestsApi';

/** "Lane Sotta" / "R+L Carriers" / "". */
export function loadDriverText(load) {
  if (!load) return '';
  return String(load.driver || load.driver_name || load.carrier_name || '').trim();
}

/** "Truck 2" / "24 ft trailer (typed)" / "". */
export function loadVehicleText(load) {
  if (!load) return '';
  return String(load.vehicle || load.vehicle_name || load.vehicle_text || '').trim();
}

/** "Today 7:42 AM by Jesse Sotta". */
export function loadedText(load, now = new Date()) {
  if (!load) return '';
  const when = clockText(load.loaded_at, now);
  const by = load.loaded_by ? ` by ${load.loaded_by}` : '';
  return when ? `${when}${by}` : (by ? `Loaded${by}` : '');
}

/** The chips for a signature: [{text, tone}] (tone = a Bootstrap colour). `deliveredAt` = the plan's delivered_at.
 *  "paper signature to file" = signed on paper and the scan is not on file yet (`paper_on_file` / a document). */
export function signChips(sign, { deliveredAt = null } = {}) {
  const chips = [];
  const s = sign && typeof sign === 'object' ? sign : null;
  const who = s && s.signed_by ? ` by ${s.signed_by}` : '';
  const paper = !!(s && (s.signature_method === 'paper' || s.status === 'paper'));
  if (s && s.status === 'signed' && !paper) {
    if (s.kind === 'pickup') chips.push({ text: `Picked up · signed${who}`, tone: 'success' });
    else if (s.kind === 'carrier_handoff') chips.push({ text: `Carrier signed${who}`, tone: 'success' });
    else chips.push({ text: `Delivered · signed${who}`, tone: 'success' });
  } else if (paper) {
    if (deliveredAt || s.kind === 'delivery') chips.push({ text: 'Delivered', tone: 'success' });
    else if (s.kind === 'pickup') chips.push({ text: 'Picked up', tone: 'success' });
    if (!s.paper_on_file && !s.document_url) chips.push({ text: 'paper signature to file', tone: 'warning' });
  } else if (deliveredAt) {
    chips.push({ text: 'Delivered', tone: 'success' });
  } else if (s && s.status === 'pending') {
    chips.push({ text: 'Waiting for signature', tone: 'warning' });
  } else if (s && s.status === 'expired') {
    chips.push({ text: 'Signing link ran out', tone: 'secondary' });
  } else if (s && s.status === 'void') {
    chips.push({ text: 'Signing cancelled', tone: 'secondary' });
  }
  if (s && s.has_problem) chips.push({ text: 'Problem noted', tone: 'danger' });
  return chips;
}

/** Bootstrap badge classes for a chip tone (text dark on the light tones). */
export function chipClass(tone) {
  if (tone === 'warning') return 'badge bg-warning text-dark';
  if (tone === 'secondary') return 'badge bg-secondary';
  if (tone === 'danger') return 'badge bg-danger';
  return 'badge bg-success';
}

/** "on their phone" / "on our device" / "". */
export function signedOnText(on) {
  if (on === 'phone') return 'on their phone';
  if (on === 'operator_device') return 'on our device';
  return '';
}

/** "PLT-T4WQ" / "PLT-T4WQ and PLT-8ZKD" / "PLT-1, PLT-2 and PLT-3". */
export function andList(names) {
  const n = (names || []).filter(Boolean);
  if (n.length <= 1) return n.join('');
  return `${n.slice(0, -1).join(', ')} and ${n[n.length - 1]}`;
}
